<template>
  <div id="profit">
    <!-- 开票列表 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="订单号" prop="orderSn"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatTimer }}</template>
      </el-table-column>
      <el-table-column label="买家名称" prop="receiverName"></el-table-column>
      <el-table-column label="付款时间">
        <template slot-scope="scope">{{ scope.row.paymentTime | formatTimer }}</template>
      </el-table-column>
      <el-table-column label="开票金额" prop="discountAmount"></el-table-column>
      <el-table-column label="发票类型">
        <template slot-scope="scope">{{ scope.row.taxType==3?'企业发票': '个人发票'}}</template>
      </el-table-column>
      <el-table-column label="发票抬头">
        <template
          slot-scope="scope"
        >{{ scope.row.taxType==3?scope.row.taxTitle:(scope.row.billHeader==null?'/':scope.row.billHeader)}}</template>
      </el-table-column>
      <el-table-column label="发票税号">
        <template slot-scope="scope">{{ scope.row.taxType==3?scope.row.taxCode:'/'}}</template>
      </el-table-column>
      <el-table-column label="开票状态">
        <template slot-scope="scope">{{ scope.row.billContent===null?'待开票':'已开票' }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
          <el-button
            v-if="scope.row.billContent===null"
            size="mini"
            type="warning"
            @click="handleSendGoods(scope.$index, scope.row)"
          >开票</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 查看详情 -->
    <!-- 开票 -->
    <div>
      <el-dialog
        title="开票"
        :visible.sync="sendGoodsdialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <!-- 发货需要的数据 -->
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
          <!-- 发票图片 -->
          <el-form-item label="电子发票" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandLogo') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'brandLogo') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handCancer()">取 消</el-button>
          <el-button type="primary" @click="handleSendExpress">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 查看订单dialog -->
    <div>
      <el-dialog title="订单详情" :visible.sync="detaildialogVisible" width="30%">
        <!-- 下单人信息 -->
        <el-descriptions class="margin-top" title :column="1" border>
          <el-descriptions-item>
            <template slot="label">订单号</template>
            {{detailData.orderSn}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">开票金额</template>
            {{detailData.discountAmount}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">联系人</template>
            {{detailData.receiverName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">联系方式</template>
            {{detailData.receiverPhone}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">联系地址</template>
            {{detailData.receiverProvince+detailData.receiverCity+detailData.receiverRegion+detailData.receiverDetailAddress}}
          </el-descriptions-item>
        </el-descriptions>
        <!-- 快递部分 -->
        <div style="margin-top:10px">
          <el-descriptions class="margin-top" title :column="1" border>
            <el-descriptions-item>
              <template slot="label">物流公司</template>
              {{detailData.deliveryCompany}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">物流单号</template>
              {{detailData.deliverySn}}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 分页 -->
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryOrderToBeInvoiced, qiniuupload, addInvoicing } from '../../api'
import moment from 'moment'
export default {
  data () {
    return {
      // 订单详情dialog
      detaildialogVisible: false,
      detailData: [],
      formLabelWidth: '100px',
      imgUrl: '',//解决图片回显问题
      uploadUrl: '', //  七牛上传地址前缀
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      ruleForm: {
        // 开票订单号
        orderId: '',
      },
      tableData: [],
      total: 0,
      currentpageIndex: 1,
      currentpageSize: 10,
      //开票弹窗
      sendGoodsdialogVisible: false
    }
  },
  filters: {
    formatTimer: function (value) {
      if (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      } else {
        return "/"
      }

    }
  },
  //进入页面之前请求数据
  mounted () {
    // 查询订单列表
    this.getInvoicingList()
    // 获取七牛token
    this.getToken()
  },
  methods: {
    //查看
    handleDetail (index, row) {
      console.log(index, row);
      this.detaildialogVisible = true
      this.detailData = row
    },
    //筛选
    handleSearch (index) {
      console.log(index);
      // this.status = index
      // this.currentpageIndex = 1
      // this.getOrderList()
    },
    // 提交电子发票
    handCancer () {
      this.sendGoodsdialogVisible = false
      this.imgUrl = ''
    },
    handleSendExpress () {
      console.log(this.imgUrl);
      //电子发票 this.imgUrl  this.ruleForm.orderId
      let para = new URLSearchParams()
      para.append('orderId', this.ruleForm.orderId)
      para.append('billContent', this.imgUrl)
      addInvoicing(para).then(data => {
        // console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.imgUrl = ''
          this.ruleForm.orderId = ''
          this.sendGoodsdialogVisible = false
          this.getInvoicingList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 七牛部分
    getToken () {
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        // console.log(res.data)
        this.qiniu.token = res.data.token
        this.uploadUrl = res.data.bucketUrl
      })
    },
    handleOnSuccess (response, file, fileList, obj) { //  上传成功之后
      this.imgUrl = this.uploadUrl + '/' + response.key
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    // 开票按钮
    handleSendGoods (index, item) {
      console.log(item);
      this.sendGoodsdialogVisible = true
      this.ruleForm.orderId = item.id
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.getInvoicingList()
    },
    getInvoicingList () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      queryOrderToBeInvoiced(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
  },

}
</script>

<style lang="stylus">
#profit {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>

